@if (isconfiged) {
  <div class="h-100">
    <div class="clr-row nxm" style="align-items: center; justify-content: space-between">
      <div class="clr-col-auto margin-12-tb">
        <div class="btn-group btn-primary btn-icon">
          <button
            class="btn btn-icon btn-success"
            [title]="'Neue Begehung durchführen' | mrTranslate"
            (click)="addBegehung()"
            [disabled]="obegeid == 0 || authService.token.rights.status <= 2">
            <cds-icon shape="file" />
          </button>
          <button
            class="btn btn-icon"
            [title]="'Begehung fortsetzen' | mrTranslate"
            (click)="continueBegehung()"
            [disabled]="!canContinueBegehung || authService.token.rights.status <= 2">
            <cds-icon shape="step-forward-2" />
          </button>
          <button
            class="btn btn-icon"
            [title]="'Begehung einrichten' | mrTranslate"
            (click)="openBegehungsEinstellungen()"
            [disabled]="authService.token.rights.status < 6">
            <cds-icon shape="cog" />
          </button>
        </div>
      </div>
      <div class="clr-col-auto margin-12-tb">
        <div class="btn-group btn-outline btn-icon">
          @if (!isRep) {
            <button
              class="btn"
              [title]="'Replikat für Begehungen erstellen' | mrTranslate"
              [disabled]="!allowRepErstellen || authService.token.rights.status <= 2"
              (click)="isUserReplikatModalOpen.set(true)">
              <cds-icon size="20" shape="rep_user" />
            </button>
          } @else {
            <button
              class="btn"
              [title]="'Replikat zurückspielen' | mrTranslate"
              (click)="stopReplicate()"
              [disabled]="authService.token.rights.status <= 2">
              <cds-icon size="20" shape="rep_upload" />
            </button>
          }
        </div>
      </div>
    </div>
    <div class="clr-row nxm" style="padding-right: 10px">
      <div class="clr-col-md-8">
        <div class="clr-row nxm" style="padding-right: 10px">
          <h4 style="margin-top: 2px">
            {{ 'Begehungsart' | mrTranslate }}
            <button
              class="btn btn-icon btn-sm nym"
              (click)="filterStore.deleteAllFilters()"
              [disabled]="filterStore.filteredRows().length == begehungTable().rows.length">
              <cds-icon shape="filter-off" [title]="'Alle Filter zurücksetzen' | mrTranslate" />
            </button>
          </h4>
        </div>
        <div class="limit-height">
          @if (begehungTable().columns.length && objekte) {
            <clr-datagrid
              #objekteGrid
              class="datagrid-compact"
              [clrDgSelectionType]="'single'"
              [clrDgSelected]="[selectedBegehung]"
              (clrDgSelectedChange)="selectedBegehung = $event[0]; selectionGridChanged($event[0])"
              [clrDgItemsIdentityFn]="row => row?.OBEGEID"
              [clrDgRowSelection]="true">
              <clr-dg-column class="icon-column"></clr-dg-column>
              @for (column of begehungTable().columns; track column.id) {
                <clr-dg-column [clrDgField]="column.id" #columns>
                  <clr-dg-filter>
                    <app-column-filter
                      #begehungen
                      [column]="column"
                      [objektTypIconValue]="filterStore.iconMap()"
                      [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                      (changes)="filterStore.onChange($event)" />
                  </clr-dg-filter>
                  <ng-template
                    [clrDgHideableColumn]="{ hidden: column.id | hideIDColumns: hides }"
                    (clrDgHiddenChange)="columnHiddenChange()">
                    {{ column.id | titlecase | mrUnitText }}
                  </ng-template>
                </clr-dg-column>
              }

              <ng-template
                clrVirtualScroll
                let-row
                [clrVirtualRowsOf]="filterStore.filteredRows()"
                [clrVirtualRowsTrackBy]="(_, row) => row?.OBEGEID">
                <clr-dg-row [clrDgItem]="row">
                  <clr-dg-cell class="icon-column">
                      @if (row['Beschreibung'] != null) {
                      <cds-icon
                        shape="info-circle"
                        style="width: 24px; height: 24px;"
                        class="clickable"
                        (click)="showInfo($event, row)">
                      </cds-icon>
                      }
                  </clr-dg-cell>

                  @for (cell of begehungTable().columns; track cell.id) {
                    <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                  }
                </clr-dg-row>
              </ng-template>
              <clr-dg-footer>
                <div class="footerbox">
                  <div>
                    <button
                      class="minibutton"
                      [title]="'Spaltenfilter löschen' | mrTranslate"
                      (click)="removeColFilter()">
                      <cds-icon shape="filter-off" />
                    </button>
                  </div>
                  <div class="dbNameTable">{{ formatDBName }}</div>
                  <div>{{ filterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</div>
                </div>
              </clr-dg-footer>
            </clr-datagrid>
          }
        </div>
      </div>

      <div class="clr-col-md-4">
        <div class="limit-height">
          <div class="clr-row nxm" style="padding-right: 10px">
            <h4 style="margin-top: 2px">{{ 'Historie' | mrTranslate }}</h4>
          </div>
          @if (begehungHistoryTable?.columns.length) {
            <clr-datagrid
              #objekteGrid
              class="datagrid-compact"
              [clrDgSelectionType]="'single'"
              [clrDgSelected]="[selectedHistoryBegehung]"
              (clrDgSelectedChange)="selectedHistoryBegehung = $event[0]; selectionHistoryChanged($event[0])"
              [clrDgRowSelection]="true"
              [clrDgItemsIdentityFn]="row => row?.ID">
              @for (column of begehungHistoryTable.columns; track column) {
                <clr-dg-column [clrDgField]="column.id">
                  <ng-container
                    *clrDgHideableColumn="{
                      hidden:
                        column.id
                        | hideIDColumns: ['_tag', 'obegeid', 'obegpid', 'OBEGEID', 'OBEGPID', 'gruppen', 'Gruppen'],
                    }">
                    {{ column.id | titlecase | mrUnitText }}
                  </ng-container>
                </clr-dg-column>
              }
              <ng-template
                clrVirtualScroll
                let-row
                [clrVirtualRowsOf]="begehungHistoryTable.rows"
                [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
                <clr-dg-row [clrDgItem]="row">
                  @for (cell of begehungHistoryTable.columns; track cell) {
                    <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                  }
                </clr-dg-row>
              </ng-template>
              <clr-dg-footer>{{ begehungHistoryTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
            </clr-datagrid>
          }
        </div>
      </div>
    </div>

    @if (selectedZuordnungTable().columns.length) {
      <div class="clr-row nxm padding-10-r">
        <div class="clr-col-md-4">
          <h4 style="margin-top: 5px">
            {{ 'Objekte' | mrTranslate }}
            <button
              class="btn btn-icon btn-sm nym"
              (click)="filterStore_II.deleteAllFilters()"
              [disabled]="filterStore_II.filteredRows().length == selectedZuordnungTable().rows.length">
              <cds-icon shape="filter-off" [title]="'Alle Filter zurücksetzen' | mrTranslate" />
            </button>
          </h4>
        </div>
      </div>
      <div class="clr-row nxm padding-10-r" style="height: calc(100% - 420px)">
        <div class="clr-col-md-12">
          <clr-datagrid
            #objekteDatagrid
            class="datagrid-compact h-100"
            [clrDgSelectionType]="'single'"
            [clrDgSelected]="[selectedObjekt]"
            (clrDgSelectedChange)="selectedObjekt = $event[0]; selectionObjektChanged($event[0])"
            [clrDgRowSelection]="true"
            [clrDgItemsIdentityFn]="row => row?.OSTAMMID">
            @if (obegpid != 0) {
              <clr-dg-column>{{ 'Abgeschlossen' | titlecase | mrTranslate }}</clr-dg-column>
              <clr-dg-column>{{ 'Datum' | titlecase | mrTranslate }}</clr-dg-column>
            }
            @for (column of selectedZuordnungTable().columns; track column.id) {
              <clr-dg-column [clrDgField]="column.id" [style.min-width.px]="column.id.length * 7.5 + 26">
                <clr-dg-filter>
                  <app-column-filter
                    #objekte
                    [column]="column"
                    [objektTypIconValue]="filterStore_II.iconMap()"
                    [uniqueColumnValues]="filterStore_II.uniqueValues()[column.id]"
                    (changes)="filterStore_II.onChange($event)" />
                </clr-dg-filter>
                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sp', 'lf', 'st', 'rep'] }">
                  {{ column.id | titlecase | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <ng-template
              clrVirtualScroll
              let-row
              [clrVirtualRowsOf]="filterStore_II.filteredRows()"
              [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID">
              <clr-dg-row [clrDgItem]="row">
                @if (obegpid != 0) {
                  <clr-dg-cell>
                    {{ row | get: getGridValue : 'closed' | tablePrettyPrint }}
                  </clr-dg-cell>
                }
                @if (obegpid != 0) {
                  <clr-dg-cell>
                    {{ row | get: getGridValue : 'date' | tablePrettyPrint }}
                  </clr-dg-cell>
                }
                @for (cell of selectedZuordnungTable().columns; track cell.id) {
                  <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
                }
              </clr-dg-row>
            </ng-template>
            <clr-dg-footer>{{ filterStore_II.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        </div>
        <div class="clr-col-md-12 margin-12-b"><app-image-slide-show [data]="selectedObjektBilder" /></div>
      </div>
    }
  </div>
} @else {
  <div class="clr-row nxm margin-20-t">
    @if (isRep || !authService.getRight('view', 'AllowVBeg')) {
      <div class="padding-10-l">{{ 'keine Daten vorhanden' | mrTranslate }}</div>
    } @else {
      <button class="btn btn-sm" style="display: block; margin: 0 auto" (click)="openBegehungsEinstellungen()" [disabled]="authService.token.rights.status < 6">
        <cds-icon shape="cog" />
        {{ 'Begehung einrichten' | mrTranslate }}
      </button>
    }
  </div>
}

@if (isReplikatProgressOpen()) {
  <app-replikat-progress
    [mode]="isRep ? 'syncback' : 'setup'"
    [setupConfig]="setupConfig()"
    [(modalOpen)]="isReplikatProgressOpen" />
}
@if (isUserReplikatModalOpen()) {
  <app-replikat-begehungen-setup
    [(setupConfig)]="setupConfig"
    (setupConfigChange)="isReplikatProgressOpen.set(true)"
    [(modalOpen)]="isUserReplikatModalOpen" />
}
